import "./App.css";
import "./assets/style.scss";
import React from "react";
import ThirtyDaysLanding from "./components/30DaysPage/ThirtyDaysLanding";
import LandindPage from "./components/LandingPage/LandindPage";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";

function App() {
  return (  
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Navbar />

      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<LandindPage />} />
          <Route path="thirtydaylanding" element={<ThirtyDaysLanding />} />
        </Routes>
      </div>

      <Footer />
    </div>
  )
}

export default App;

// const router = createBrowserRouter(
//   createRoutesFromElements(
//     <Route path="/" element={<Layout />}>
//       <Route path="landing" element={<LandindPage />} />
//       <Route path="thirtydaylanding" element={<ThirtyDaysLanding />} />
//       {/* <Route path="contact" element={<Contact />} />
//       <Route path="user/:userid" element={<User />} />
//       <Route
//       loader={githubInfoLoader}
//       path="github"
//       element={<Github />}
//       /> */}
//     </Route>
//   )
// )


// const container = document.getElementById("root");
// const root = ReactDOMClient.createRoot(container);

// root.render(
//   <React.StrictMode>
//     <RouterProvider router={Router} />
//   </React.StrictMode>
// );
